import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import TestimonialSection from './components/TestimonialSection';
import MaintenanceSection from './components/MaintenanceSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <PortfolioSection />
        <TestimonialSection />
        <MaintenanceSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;